import { createClient } from 'contentful';

const SPACE_ID = process.env.REACT_APP_CONTENTFUL_SPACE_ID || 'tbu6yo6b5o8c';
const ACCESS_TOKEN = process.env.REACT_APP_CONTENTFUL_ACCESS_TOKEN || 'e218c3e95c9baa00b1ba82bc971f8636489205545cf5cfe389c809f2552029b7';
const HOST = process.env.REACT_APP_CONTENTFUL_HOST || 'cdn.contentful.com';
const SITE = 'WRestaurants';

const client = createClient({
  space: SPACE_ID,
  accessToken: ACCESS_TOKEN,
  host: HOST,
});

// get navigation
export const getNavi = (locale) => client.getEntries({
  content_type: 'navigation',
  'fields.site': SITE,
  limit: 1,
  include: 2,
  locale,
  select: [
    'fields.entries',
  ],
})
.then(response => response.items[0].fields.entries)
.catch(error => {
  console.log('error occured')
  console.log(error)
});

export const getPage = (slug, locale) => client.getEntries({
  content_type: 'page',
  'fields.site': SITE,
  'fields.slug': slug,
  include: 2,
  locale,
  select: [
    'fields.slug',
    'fields.title',
    'fields.elements',
  ],
})
.then(response => response.items[0].fields)
.catch(error => {
  console.log('error occured')
  console.log(error)
});

// get open hours
export const getHours = (locale) => client.getEntries({
  content_type: 'contactUs',
  'fields.site': SITE,
  limit: 1,
  locale,
  select: [
    'fields.openingHours'
  ]
})
.then(response => response.items[0].fields.openingHours)
.catch(error => {
  console.log('error occured')
  console.log(error)
});

// get front page
export const getFront = (locale) => client.getEntries({
  content_type: 'frontPage',
  'fields.site': SITE,
  limit: 1,
  include: 10,
  locale,
  select: [
    'fields.header',
    'fields.lifts'
  ]
})
.then(response => {
  return {
    "header":response.items[0].fields.header.fields,
    "lifts":response.items[0].fields.lifts
  }
})
.catch(error => {
  console.log('error occured')
  console.log(error)
});

// get open hours
export const getContact = (locale) => client.getEntries({
  content_type: 'contactUs',
  'fields.site': SITE,
  limit: 1,
  locale,
  select: [
    'fields.header',
    'fields.specialHours',
    'fields.onlineInvoices',
    'fields.services',
    'fields.footerFirstColumn',
    'fields.footerLinks'
  ]
})
.then(response => {
  return {
  "header":response.items[0].fields.header.fields,
  "specialHours":response.items[0].fields.specialHours,
  "onlineInvoices":response.items[0].fields.onlineInvoices,
  "services":response.items[0].fields.services,
  "footerFirstColumn":response.items[0].fields.footerFirstColumn,
  "footerLinks":response.items[0].fields.footerLinks
}})
.catch(error => {
  console.log('error occured')
  console.log(error)
});

// get Blogs
export const getBlogs = (locale, limit = 1, offset = 0) => client.getEntries({
  content_type: 'blogPost',
  'fields.site': SITE,
  order: '-fields.published',
  limit: limit,
  skip: offset,
  locale,
  include: 10
})
.then(response => response.items)
.catch(error => {
  console.log('error occured')
  console.log(error)
});

// get Press Releases
export const getPress = (locale, limit = 1, offset = 0) => client.getEntries({
  content_type: 'pressRelease',
  'fields.site': SITE,
  order: '-fields.published',
  limit: limit,
  skip: offset,
  locale,
  include: 10
})
.then(response => response.items)
.catch(error => {
  console.log('error occured')
  console.log(error)
});

// get Media bank
export const getMedia = (locale) => client.getEntries({
  content_type: 'mediaBank',
  'fields.site': SITE,
  order: 'fields.order',
  locale,
  include: 10
})
.then(response => response.items)
.catch(error => {
  console.log('error occured')
  console.log(error)
});

// get BW in media
export const getBWinMedia = (locale, limit = 1, offset = 0) => client.getEntries({
  content_type: 'bwInMedia',
  'fields.site': SITE,
  order: '-fields.published',
  limit: limit,
  skip: offset,
  locale,
  include: 10
})
.then(response => response.items)
.catch(error => {
  console.log('error occured')
  console.log(error)
});

// get jobs
export const getJobs = (locale) => client.getEntries({
  content_type: 'job',
  'fields.site': SITE,
  order: '-sys.updatedAt',
  locale,
  include: 10
})
.then(response => response.items)
.catch(error => {
  console.log('error occured')
  console.log(error)
});

// get jobContainers
export const getJobContainers = (locale) => client.getEntries({
  content_type: 'jobOpenings',
  'fields.site': SITE,
  order: '-sys.updatedAt',
  locale,
  include: 10
})
.then(response => response.items)
.catch(error => {
  console.log('error occured')
  console.log(error)
});



// WEBPACK FOOTER //
// ./src/api/contentfulAPI.js